/**
 * VP-18267: an accession id is a run of digits. Anything else - "", null, or the literal
 * "undefined" / "null" that a broken link's query string carries - must be treated as absent,
 * so the patient is shown the accession input instead of a dead-end verification screen.
 */
export function isValidAccessionId(value) {
  if (value === null || value === undefined) return false;
  return /^\d+$/.test(String(value).trim());
}

/** The accession as a clean string, or "" when it is not usable. */
export function normalizeAccessionId(value) {
  return isValidAccessionId(value) ? String(value).trim() : "";
}
